import { faCirclePlus, faEdit, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { KeyboardEvent, useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { Pagination } from "../../components/Pagination"
import { IPessoas } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import "./style.css"

export function Pessoas() {
  const navigate = useNavigate()
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [list, setList] = useState<IPessoas[]>([])

  const [pesquisa, setPesquisa] = useState("")

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  // const [limitPage, setLimitPage] = useState(25);
  const limitPage = 25

  const loadList = useCallback(async (pesq?: string) => {
    setLoading(true)
    setTxtLoading("Carregando lista de Pessoas...")

    const canLoad = await checkToken()
    if (!canLoad)
      return;

    await api.get(`pessoas?limit=${limitPage}&cursor=${(limitPage * page) - limitPage}&nome=${pesq ? pesq : ""}`)
      .then((res) => {
        if (!res.data)
          return

        setList(res.data.result)

        const newMaxPage = Math.ceil(res.data.total / limitPage);
        setMaxPage(newMaxPage < 1 ? 1 : newMaxPage);

      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao tentar recuperar lista de pessoas. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, page])

  const handleDelete = async (item: IPessoas) => {
    if (!window.confirm(`Deseja realmente excluir ${item.nome}?`))
      return

    setLoading(true)
    setTxtLoading("Excluindo cadastro...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    try {
      await api.delete("pessoas", {
        data: { id: item.id }
      });

      loadList(pesquisa);
    } catch (err: any) {
      if (err.response?.data?.message)
        alert(err.response?.data?.message);
      else
        alert("Erro ao excluir o cadastro. Tente novamente mais tarde");

      setLoading(false);
      setTxtLoading("");
    }
  }

  const handlePesquisaKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter")
      loadList();
  }

  useEffect(() => {
    if (tokens?.token)
      loadList()
  }, [tokens, page, loadList])

  return (
    <div id="pgPessoas">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>

          <div className="topo">
            <Input
              mask="none"
              value={pesquisa}
              inputMaskChange={(v) => { setPesquisa(v) }}
              placeholder="Pesquisa por nome"
              onKeyUp={(e) => handlePesquisaKeyUp(e)}
            />

            <button onClick={() => { loadList(pesquisa) }} className="btn-purple">
              <FontAwesomeIcon icon={faSearch} />
            </button>

            <button onClick={() => navigate("novo")} className="btnNovo btn-green">
              <FontAwesomeIcon icon={faCirclePlus} />
              NOVO
            </button>
          </div>

          <div className="painel table">
            <div className="head">
              <span>Nome</span>
            </div>

            <div className="tableContent">
              {list && list.map(item => (
                <div className="rowTable" key={item.id}>
                  <button className="btn-red btnSmall" onClick={() => handleDelete(item)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </button>

                  <button className="btn-purple btnSmall" onClick={() => navigate(`${item.id}`)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <span>{item.nome}</span>
                </div>
              ))}
            </div>
          </div>

          <Pagination maxPage={maxPage} page={page} setPage={setPage} />
        </>
      )}

    </div>
  )
}